import { ref } from 'vue'

const body = document.body

const state = ref({
  open: false,
  hover: false,
  passive: false,
  collapsed: false,
})

function openMenu() {
  state.value = {
    open: true,
    hover: true,
    passive: false,
    collapsed: false,
  }
}

function closeMenu() {
  state.value = {
    open: false,
    hover: false,
    passive: false,
    collapsed: true,
  }
}

function handleCloseMenu(v) {
  const el = v.target
  const clickInsideSidebar = Boolean(el.closest('.OSidebar'))
  const isBtnOpen = el.parentNode.classList.contains('OSidebar-open')

  if (!clickInsideSidebar && !isBtnOpen) closeMenu()
}

function toggleMenu() {
  state.value.open ? closeMenu() : openMenu()
}

// watch(state, (v) => {
//   setTimeout(() => {
//     v.open
//       ? body.addEventListener('click', handleCloseMenu)
//       : body.removeEventListener('click', handleCloseMenu)
//   }, 500)
// })

export { state, openMenu, closeMenu, toggleMenu }
